import _ from '@lodash';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { ThemeProvider } from '@material-ui/core/styles';
import { selectMainTheme } from 'app/store/fuse/settingsSlice';
import { useHistory } from 'react-router';
import { yupResolver } from '@hookform/resolvers/yup';
import { showMessage } from 'app/store/fuse/messageSlice';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';

import DatasetService from 'app/admin/dataset/service/DatasetService';

export function CreateDatasetDialog(props) {
    const history = useHistory();
    const { t } = useTranslation(['common']);
    const dispatch = useDispatch();

    const mainTheme = useSelector(selectMainTheme);

    const schema = yup.object().shape({
        datasetName: yup.string().nullable().required(t('validation:FIELD_REQUIRED'))
    });

    const getDefaultValues = () => {
        let defaultValues = {};
        return defaultValues;
    };

    const methods = useForm({
        defaultValues: getDefaultValues(),
        mode: 'onChange',
        resolver: yupResolver(schema)
    });

    const handleSave = value => {
        DatasetService.createFromMeasurement(props.measurement, value.datasetName).then(response => handleResponse(response)).catch(err => handleCatch(err));
    };

    const handleResponse = (response) => {
        console.log(response);
        dispatch(showMessage({ message: 'Dataset created successfully!' }));
        props.onCancel();
    };

    const handleCatch = (error) => {
        console.log(error);
        dispatch(showMessage({ message: 'Error while creating dataset!' }));
    };

    const handleCancel = () => {
        props.onCancel();
    };

    return (
        <ThemeProvider theme={mainTheme}>
            <Dialog open fullWidth>

                <DialogTitle disableTypography className="border-b">
                    Create Datasetr
                </DialogTitle>

                <DialogContent className="p-20">

                    <FormProvider {...methods}>
                        <Controller
                            control={methods.control}
                            name="datasetName"
                            render={({ field, fieldState }) => (
                                <EditFormTextField
                                    field={field}
                                    fieldState={fieldState}
                                    config={{ topic: 'common' }}
                                    fieldConfig={{
                                        key: 'datasetName',
                                        text: 'Dataset name',
                                        required: true
                                    }}
                                />
                            )}
                        />
                    </FormProvider>

                </DialogContent>

                <DialogActions className="justify-between border-t p-20">

                    <Button onClick={() => { handleCancel(); }}>
                        {t('CANCEL')}
                    </Button>

                    <Button onClick={methods.handleSubmit(handleSave)} color="primary" autoFocus>
                        Create
                    </Button>

                </DialogActions>

            </Dialog>
        </ThemeProvider>
    );
}

export default CreateDatasetDialog;